import { inject, Injectable } from '@angular/core';
import { ApiDataAccess } from '@softline/core';
import {
  SOFTLINE_API_MDC_INVENTORY_ADD_PALLET,
  SOFTLINE_API_MDC_INVENTORY_BY_ID,
  SOFTLINE_API_MDC_INVENTORY_CREATE,
  SOFTLINE_API_MDC_INVENTORY_EXISTS,
  SOFTLINE_API_MDC_INVENTORY_FINALIZE,
  SOFTLINE_API_MDC_INVENTORY_ITEMS,
} from '../mde-inventory.api';
import { MdcInventory } from '../types/mdc-inventory';
import { CreateMdcInventoryItem, MdcInventoryItem } from '../types/inventory-item';
import { SOFTLINE_API_MDC_INVENTORY_PRODUCT_DELETE_ITEMS } from '../mde-inventory.api';

@Injectable({ providedIn: 'root' })
export class MdcInventoryRepository {
  private readonly dataAccess = inject(ApiDataAccess);

  async loadInventory(date: string, stockId: number): Promise<MdcInventory | null> {
    return this.dataAccess.create(
      {
        path: SOFTLINE_API_MDC_INVENTORY_EXISTS,
      },
      {
        date,
        stockId,
      }
    );
  }

  async loadById(id: number): Promise<MdcInventory | null> {
    return this.dataAccess.get({
      path: SOFTLINE_API_MDC_INVENTORY_BY_ID,
      pathParams: {
        id,
      },
    });
  }

  async create(date: string, stockId: number): Promise<MdcInventory> {
    return this.dataAccess.create(
      {
        path: SOFTLINE_API_MDC_INVENTORY_CREATE,
      },
      {
        documentDate: date,
        stockId,
      }
    );
  }

  async loadItems(id: number): Promise<MdcInventoryItem[]> {
    return this.dataAccess.get({
      path: SOFTLINE_API_MDC_INVENTORY_ITEMS,
      pathParams: { id },
    });
  }

  async addItem(id: number, payload: CreateMdcInventoryItem): Promise<MdcInventoryItem> {
    return this.dataAccess.create(
      {
        path: SOFTLINE_API_MDC_INVENTORY_ITEMS,
        pathParams: { id },
      },
      payload
    );
  }

  async addPallet(id: number, palletId: number): Promise<MdcInventoryItem[]> {
    return this.dataAccess.create(
      {
        path: SOFTLINE_API_MDC_INVENTORY_ADD_PALLET,
        pathParams: { id, palletId },
      },
      {}
    );
  }

  async deleteItemsOfProduct(
    id: number,
    productId: string | number
  ): Promise<MdcInventory> {
    return this.dataAccess.delete({
      path: SOFTLINE_API_MDC_INVENTORY_PRODUCT_DELETE_ITEMS,
      pathParams: { id, productId },
    });
  }

  async finalize(id: string | number): Promise<void> {
    return this.dataAccess.create(
      {
        path: SOFTLINE_API_MDC_INVENTORY_FINALIZE,
        pathParams: { id },
      },
      {}
    );
  }

  async delete(id: number): Promise<MdcInventory> {
    return this.dataAccess.delete({
      path: SOFTLINE_API_MDC_INVENTORY_BY_ID,
      pathParams: { id },
    });
  }
}
